import React, { useState } from "react";
import { Card, Button, Form, Spinner } from "react-bootstrap";
import "./AdminCSS/admin.css";

const API_URL = process.env.REACT_APP_API_URL;

const PatientLookup = () => {
  const [patientId, setPatientId] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLookup = async () => {
    if (!patientId) {
      alert("Please enter a Patient ID");
      return;
    }

    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");


    setLoading(true);

    try {
      // Check latest vitals endpoints
      const endpoints = [
        `/vitals/patient/${patientId}/temperature/latest`,
        `/vitals/patient/${patientId}/heart_rate/latest`,
        `/vitals/patient/${patientId}/spo2/latest`,
        `/vitals/patient/${patientId}/battery/latest`,
        `/vitals/patient/${patientId}/steps/latest`,
      ];

          // Fetch all vitals in parallel
      const results = await Promise.all(
      endpoints.map(async (endpoint) => {
        try {
          const res = await fetch(`${API_URL}${endpoint}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (!res.ok) return null;
          return await res.json();
        } catch {
          return null;
        }
      })
    );

      const hasData = results.some(r => r && (
        r.temperature !== undefined || 
        r.heart_rate !== undefined || 
        r.spo2 !== undefined || 
        r.battery !== undefined || 
        r.steps !== undefined
      ));
            // console.log("hasdata",hasData)

      if (!hasData) {
        alert("No vitals found for this patient.");
      } else {
        // Open new window with patient vitals page
        const width = 1000;
        const height = 700;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;

        window.open(
          `/patient-vitals?patientId=${patientId}`,
          `PatientVitals_${patientId}`,
          `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`
        );
      }
    } catch (err) {
      alert("Network or server error.");
    }

    setLoading(false);
  };

  return (
    <Card className="card-patient-vitals">
      <Card.Header>
        <span role="img" aria-label="pulse">
          🩺
        </span>{" "}
        Patient Lookup
      </Card.Header>
      <Card.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleLookup();
          }}
        >
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              value={patientId}
              onChange={(e) =>
                setPatientId(e.target.value.replace(/\D/g, "")) // only numbers
              }
              placeholder="Enter Patient ID"
              required
            />
          </Form.Group>

          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Opening...
              </>
            ) : (
              "Lookup"
            )}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default PatientLookup;